import todoFormCategory from './todoFormCategory';
import {save} from '../../app-components/action/SaveAction';
import {cancelButton} from '../../app-components/action/CloseAction';

let header = {
  title: 'Edit To-Do Task Category',
  actions: [cancelButton(), save()],
};

let uri = ({navigation}) => {
  return {
    query: {
      id: 'todoCategoryList',
      relationValue: {
        model: 'TodoCategory',
        _id: navigation.state.params.item._id,
        relation: '_id',
      },
      limit: 1,
    },
    model: 'TodoCategory',
  };
};
export default todoFormCategory({uri, editable: false, header});
